






















import {Component, Prop, Vue} from "vue-property-decorator";
import PlayerHead from "@/components/PlayerHead.vue";
import Player from "@/components/Player.vue";
import {PlayerConfig} from "@/interfaces/player.interface";
import {IFilm} from "@/interfaces/film.interface";

@Component({
  components: {
    PlayerHead,
    Player
  }
})

export default class VideoBox extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  ignorePageMarginBreakpoint = PlayerConfig.IgnorePageMarginBreakpoints.MOBILE;

  @Prop() item: IFilm;
  @Prop() hideControls: boolean;
  @Prop({ default: false }) hideActions?: boolean;

  get getVideoInfo() {
    return {
      title: this.item?.title,
      director: this.item?.director,
      year: this.item?.year,
      description: this.item?.info_text ? this.item?.info_text : this.item?.description,
      video_start: this.item?.video_start,
      loop_start: this.item?.loop_start,
      loop_end: this.item?.loop_end,
    }
  }
}
